var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 56,
    viewBox: "0 0 1920 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1920 0V54.8128L1880.62 54.7758L1809.84 55.848L1739.06 54.5663L1668.29 54.4883L1597.52 54.3363L1526.74 56L1455.97 54.8333L1385.19 54.6813L1314.42 54.6444L1243.65 54.7758L1172.88 54.6608L1102.11 55.6919L1031.34 54.6033L960.57 55.3304L889.8 54.7183L819.02 55.4824L748.25 54.7019L677.48 55.885L606.71 55.1948L535.94 55.3674L465.17 54.5293L394.4 54.5458L323.63 55.6755L252.86 54.9689L182.09 54.3157L111.32 54.6238L40.55 55.3879L0 55.2359V0H1920Z",
    fill: "#FF9FD4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavPink);
export default __webpack_public_path__ + "static/media/nav_pink.09a956ff414f628639a080c027ff82f3.svg";
export { ForwardRef as ReactComponent };